import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import { utils as macheteUtils } from 'src/machete-redux';
import MeasureNumber from 'src/components/MeasureSidebar/MeasureNumber';
import constants from 'src/constants';
import {
  Container,
  ThumbnailWithCount,
  CountOverlay,
  Count,
  Details,
  Name,
  Area,
} from './styled';

const { UNITS } = constants.measure;

export default class SurfaceAreaItem extends PureComponent {
  propTypes = {
    thumbnailUrl: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    area: PropTypes.number.isRequired,
    uuids: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  @autobind
  onlyShowSelectedElements() {
    macheteUtils.onlyShowSelectedElements(this.props.uuids);
  }

  render() {
    const { thumbnailUrl, count, name, area } = this.props;

    return (
      <Container onClick={this.onlyShowSelectedElements}>
        <ThumbnailWithCount src={thumbnailUrl}>
          <CountOverlay>
            <Count data-selenium="surfaceAreaCountText">{count}</Count>
          </CountOverlay>
        </ThumbnailWithCount>
        <Details>
          <Name data-selenium="surfaceAreaNameText">{name}</Name>
          <Area>
            <MeasureNumber
              number={area}
              unit={UNITS.feet.abbreviation}
              isSquare
            />
          </Area>
        </Details>
      </Container>
    );
  }
}
